import { marked } from 'marked';
import PropTypes from 'prop-types';
import React from 'react';

marked.setOptions({ gfm: true, breaks: true });

function Markdown({ source, className, tag: Tag = 'span' }) {
  if (!source) {
    return null;
  }

  return <Tag className={className} dangerouslySetInnerHTML={{ __html: marked.parse(source) }} />;
}

Markdown.propTypes = {
  source: PropTypes.string,
  className: PropTypes.string,
  tag: PropTypes.string,
};

export default Markdown;
